module.exports = __webpack_public_path__ + "r-v3/img/mic_error.b6e280f9.svg";